import React from 'react';
import { Box, Link } from 'rebass';

import { Text } from '../../../Components/Base';
import { SPACE, COLOR } from '../../../Components/Theme';
import { getConfig } from '../../../Util/Config';

const LinkSchoolErrorContact = ({ errorText }) => {
  const { lineContactLink } = getConfig();
  return (
    <Box css={{ textAlign: 'center' }}>
      <Text mt={SPACE.medium}>{errorText}</Text>
      <Text style={{ display: 'inline-block' }} mt={SPACE.medium} mr={SPACE.xsmall}>
        {`กรุณาติดต่อผ่าน Line:`}
      </Text>
      <Link style={{ display: 'inline-block' }} href={lineContactLink} color={COLOR.primary}>
        @tcastermock
      </Link>
    </Box>
  );
};

export default LinkSchoolErrorContact;
